import { render, staticRenderFns } from "./CampaignTable.vue?vue&type=template&id=15b68d6e&scoped=true&"
import script from "./CampaignTable.vue?vue&type=script&lang=js&"
export * from "./CampaignTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignTable.vue?vue&type=style&index=0&id=15b68d6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b68d6e",
  null
  
)

export default component.exports